import { createContext, useContext } from 'react'

export type UseAuth = () => {
  isAuthenticated: boolean
}

const UseAuthContext = createContext<UseAuth | null>(null)
UseAuthContext.displayName = 'UseAuth'

export const UseAuthContextProvider = UseAuthContext.Provider

export const useAuthHook = () => {
  const hook = useContext(UseAuthContext)

  if (hook === null) {
    throw new Error('There is no UseAuth hook in context!')
  }

  return hook
}
